/// <amd-module name="Build/Pipelines/Constants" />

export namespace RunFilterKeys {
    export const BranchFilter = "branchFilter";
    export const KeywordFilter = "keywordFilter";
    export const RepositoryFilter = "repositoryFilter";
    export const RequestedForFilter = "requestedForFilter";
    export const ResultFilter = "resultFilter";
    export const StatusFilter = "statusFilter";
    export const TagFilter = "tagFilter";
}

// casing for these is different because they will be prefixed with "pipeline" in urls
export namespace PipelineFilterKeys {
    export const NameFilter = "NameFilter";
}

export namespace FilterRouteKeys {
    export const BranchSearch = "branchName";
    export const DefinitionId = "definitionId";
    export const KnownBranches = "knownBranches";
    export const KnownRepositories = "knownRepos";
    export const RepositorySearch = "repoName";
}

export const BatchingDelayInMs = 3 * 1000;
export const MaxUpdates = 25;
